<template>
	<div>
		<div
			class="modal fade product-tags"
			id="taggableProduct"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content product-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Tags</h5>
					</div>
					<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
					<div class="modal-body" style="margin-top:25px" v-else>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Brand Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="brandTags"
								    :options="tagsList.filter(tag => tag.type === 'brand_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addBrandTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Brand Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>

						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Category Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="categoryTags"
								    :options="tagsList.filter(tag => tag.type === 'category_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addCategoryTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Category Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>

						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Sub-Category Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="subcategoryTags"
								    :options="tagsList.filter(tag => tag.type === 'sub_category_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addSubcategoryTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Sub-Category Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Style Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="styleTags"
								    :options="tagsList.filter(tag => tag.type === 'style_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addStyleTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Style Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Product Group Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="productGroupTags"
								    :options="tagsList.filter(tag => tag.type === 'product_group_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addProductGroupTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Product Group Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Size Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="sizeTags"
								    :options="tagsList.filter(tag => tag.type === 'size_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addSizeTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Size Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Flavor Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="flavorTags"
								    :options="tagsList.filter(tag => tag.type === 'flavor_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addFlavorTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Flavor Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">GL Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="glTags"
								    :options="tagsList.filter(tag => tag.type === 'gl_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addGLTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select GL Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Competitor Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="competitorTags"
								    :options="tagsList.filter(tag => tag.type === 'competitor_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addCompetitorTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Competitor Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Color Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="colorTags"
								    :options="tagsList.filter(tag => tag.type === 'color_product')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addColorTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Color Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="productTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" @click="hideModal()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button
								:disabled="[].concat(this.brandTags, this.categoryTags, this.subcategoryTags, this.styleTags, this.tactic1Tags, this.tactic2Tags, this.glTags).length === 0"
								type="button"
								class="btn btn-primary"
								@click = "saveTagsForproduct()"
								>Save changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "Tagproduct",
		components: {
			Multiselect
		},
		data() {
			return {
				// tags:[],
				brandTags: [],
				categoryTags: [],
				subcategoryTags:[],
				styleTags: [],
				productGroupTags: [],
				sizeTags: [],
				flavorTags: [],
				glTags: [],
				competitorTags: [],
				colorTags: [],
				tagsList:[],
				selectedproducts:[],
				productsList:[],
				isLoading:false
			};
		},
		mounted() {
			this.getTagsList({ partneruuid: this.$store.state.selectedVendorPartnerUuid, isSeller: this.$store.state.isSeller })
		},
		methods: {
			addBrandTag(name){
				var pay = { title: name, type: 'brand_product' }
				this.brandTags = pay
			},
			addCategoryTag(name){
				var pay = { title: name, type: 'category_product'  }
				this.categoryTags = pay
			},
			addSubcategoryTag(name){
				var pay = { title: name, type: 'sub_category_product'  }
				this.subcategoryTags = pay
			},
			addStyleTag(name){
				var pay = { title: name, type: 'style_product'  }
				this.styleTags = pay
			},
			addProductGroupTag(name){
				var pay = { title: name, type: 'product_group_product'  }
				this.productGroupTags = pay
			},
			addSizeTag(name){
				var pay = { title: name, type: 'size_product'  }
				this.sizeTags = pay
			},
			addFlavorTag(name){
				var pay = { title: name, type: 'flavor_product'  }
				this.flavorTags = pay
			},
			addGLTag(name){
				var pay = { title: name, type: 'gl_product'  }
				this.glTags = pay
			},
			addCompetitorTag(name){
				var pay = { title: name, type: 'competitor_product'  }
				this.competitorTags = pay
			},
			addColorTag(name){
				var pay = { title: name, type: 'color_product'  }
				this.colorTags = pay
			},
			getTagsList(payload){
				const vm = this;
				const additionalOptions = [
					{type: 'brand_product', title: 'Obsolete'},
					{type: 'category_product', title: 'Obsolete'},
					{type: 'sub_category_product', title: 'Obsolete'},
					{type: 'style_product', title: 'Obsolete'},
					{type: 'product_group_product', title: 'Obsolete'},
					{type: 'size_product', title: 'Obsolete'},
					{type: 'flavor_product', title: 'Obsolete'},
					{type: 'gl_product', title: 'Obsolete'},
					{type: 'competitor_product', title: 'Obsolete'},
					{type: 'color_product', title: 'Obsolete'},
				]
				this.$store.dispatch("product/getTagOptions", payload).then((res) => {
					vm.tagsList = (res || []).concat(additionalOptions)
					this.$store.state.listOfTags = vm.tagsList
				})
			},
			hideModal(){
				// this.tags = [];
				this.tagsList = []
				this.selectedproducts = [];
				this.productsList = [];
				this.brandTags = [];
				this.categoryTags = [];
				this.subcategoryTags = [];
				this.styleTags = [];
				this.productGroupTags = [];
				this.sizeTags = [];
				this.flavorTags = [];
				this.glTags = [];
				this.competitorTags = [];
				this.colorTags = [];			
				this.$emit('closeModal')
			},
			saveTagsForproduct(){
				let payload = {
					isSeller: this.$store.state.isSeller,
					productIds: this.$store.state.product.selectedProducts.map(p => p.id),
				    tags:[].concat(this.brandTags || [], 
					this.categoryTags || [], 
					this.subcategoryTags || [], 
					this.styleTags || [], 
					this.productGroupTags || [], 
					this.sizeTags || [], 
					this.flavorTags || [],
					this.glTags || [],
					this.competitorTags || [],
					this.colorTags || []),
				}
				this.isLoading = true;
				let vm = this;
				this.$store.dispatch("product/saveBulkTag", payload).then((res) => {
					vm.isLoading = false
					vm.hideModal()
					vm.$store.dispatch("product/getproductList", {}).then(res => {
							console.log(res);
							vm.getTagsList({ partneruuid: this.$store.state.selectedVendorPartnerUuid, isSeller: this.$store.state.isSeller })
					});
				})
			}
		}
	};
</script>


<style lang="scss">
.product-tags {
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
}
.product-tags {
	.multiselect__option span{
		text-transform: none !important;
	}
}
.product-tags {
	.multiselect__tag{
		text-transform: none !important;
	}
}

</style>
